import { render } from "./ManageModal.vue?vue&type=template&id=48252728&ts=true"
import script from "./ManageModal.vue?vue&type=script&lang=ts"
export * from "./ManageModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__